// Warna chip/lencana yang ikut tema. Dulu pasangan {warna, latar} ditulis sebagai
// hex tetap (mis. teks #1E4A6B di atas #DCE6EE): terbaca di tema terang, tetapi
// di tema gelap latarnya menjadi blok terang yang mencolok.
//
// Keduanya diturunkan dari satu warna dasar lewat color-mix terhadap token tema:
//  - tintBg: warna dasar tipis di atas permukaan  (terang → pastel, gelap → arang berwarna)
//  - tintFg: warna dasar bercampur teks utama      (terang → lebih pekat, gelap → lebih terang)
// sehingga kontras terjaga di kedua tema tanpa dua tabel warna.
export const tintBg = (color, pct = 14) => `color-mix(in srgb, ${color} ${pct}%, var(--surface))`
export const tintFg = (color, pct = 62) => `color-mix(in srgb, ${color} ${pct}%, var(--text))`
